/**
 * ============================================================================
 * useChangeRequestsQuery — Change Control register (Phase 6c CC Impact Engine).
 * Lists cc_impact.change_requests for the tenant. GET /api/v1/change-requests.
 * Added so Change Control has a real register/queue under Quality Events
 * (previously only the "Propose Change" action + deep-link detail existed, so it
 * read as "missing" — Mohanad review, 2026-05-31).
 * ============================================================================ */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';

export interface ChangeRequestItem {
  change_request_id: string;
  origin: string;
  change_type: string;
  subject_entity_type: string;
  subject_entity_id: string | null;
  title: string;
  rationale: string | null;
  proposer_user_id: string;
  status: string;
  created_at_utc: string;
  updated_at_utc: string;
}

export interface ChangeRequestsResponse {
  items: ChangeRequestItem[];
  total?: number;
}

export function useChangeRequestsQuery(): UseQueryResult<ChangeRequestsResponse> {
  return useQuery<ChangeRequestsResponse>({
    queryKey: ['change-requests', 'register'],
    queryFn: ({ signal }) =>
      apiFetch<ChangeRequestsResponse>('/api/v1/change-requests', { signal }),
    staleTime: 30_000,
  });
}
